export const getUsedVisualAttribute = (variants?: Array<GQL.IProductVariant>, attributes?: Array<GQL.IAttribute>) => {
    if (variants == undefined) {
        return undefined;
    }

    if (Array.isArray(attributes)) {
        for (const variant of variants || []) {
            const visualValueId = (variant.definition || {}).visual;
            if (visualValueId == undefined) {
                continue;
            }

            let attributeId: string | undefined = undefined;
            for (const key of Object.keys(variant.definition)) {
                if (key == 'visual') {
                    continue;
                }

                if (Array.isArray(visualValueId)) {
                    if (visualValueId.some(id => variant.definition[key])) {
                        attributeId = key;
                        break;
                    }
                } else {
                    if (variant.definition[key] == visualValueId) {
                        attributeId = key;
                        break;
                    }
                }
            }

            if (attributeId != undefined) {
                return attributes.find(a => a.id == attributeId);
            }
        }
    } else {
        for (const variant of variants || []) {
            const visualValueId = (variant.definition || {}).visual;
            if (visualValueId == undefined) {
                continue;
            }

            let attributeId: string | undefined = undefined;
            for (const key of Object.keys(variant.definition)) {
                if (key == 'visual') {
                    continue;
                }

                if (Array.isArray(visualValueId)) {
                    if (visualValueId.some(id => variant.definition[key])) {
                        attributeId = key;
                        break;
                    }
                } else {
                    if (variant.definition[key] == visualValueId) {
                        attributeId = key;
                        break;
                    }
                }
            }

            const tempValue = (variant.attributeValues || []).find(v => v.attribute.id == attributeId);
            if (tempValue) {
                return tempValue.attribute;
            }
        }
    }

    return undefined;
};



// WEBPACK FOOTER //
// ./src/helpers/Variants/getUsedVisualAttribute.ts